"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var Icon_1 = tslib_1.__importDefault(require("../Icon"));

var styles = tslib_1.__importStar(require("./Counter.style"));

function Counter(_ref) {
  var className = _ref.className,
      min = _ref.min,
      max = _ref.max,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? min : _ref$value,
      onChange = _ref.onChange;

  var _react_1$useState = react_1.useState(value),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      count = _react_1$useState2[0],
      setCount = _react_1$useState2[1];

  var handleCountChange = function handleCountChange(val) {
    var draftValue = val;
    if (val < min) draftValue = min;
    if (val > max) draftValue = max;
    setCount(draftValue);
    onChange && onChange(draftValue);
  };

  var isMinDisabled = count === min;
  var isPlusDisabled = count === max;
  react_1.useEffect(function () {
    setCount(value);
  }, [value]);
  return jsx_runtime_1.jsx("div", Object.assign({
    className: className,
    css: styles.root
  }, {
    children: jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.container
    }, {
      children: [jsx_runtime_1.jsx("button", Object.assign({
        type: "button",
        css: styles.button,
        disabled: isMinDisabled,
        onClick: handleCountChange.bind(null, count - 1)
      }, {
        children: jsx_runtime_1.jsx(Icon_1.default, {
          name: isMinDisabled ? 'ic_minus_xs_gray_300' : 'ic_minus_sm_blue_400'
        }, void 0)
      }), void 0), jsx_runtime_1.jsx("div", Object.assign({
        css: styles.value
      }, {
        children: count
      }), void 0), jsx_runtime_1.jsx("button", Object.assign({
        type: "button",
        css: styles.button,
        disabled: isPlusDisabled,
        onClick: handleCountChange.bind(null, count + 1)
      }, {
        children: jsx_runtime_1.jsx(Icon_1.default, {
          name: isPlusDisabled ? 'ic_plus_xs_gray_300' : 'ic_plus_xs_blue_400'
        }, void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
}

exports.default = Counter;